import { fetchRfiService as fetchWithToken } from '../utils/fetchRfiService';
import { getApiBaseUrl } from '../config';
import { headers, HttpMethod } from '../constants';
import { VirtualFolderResponse } from '../types';
import { CreateSDKConfig } from './types';

const VirtualFoldersApi = ({ projectId }: CreateSDKConfig) => {
  const API_URL = getApiBaseUrl(projectId);
  return {
    create(): Promise<VirtualFolderResponse> {
      const url = `${API_URL}/rfis/virtual-folders`;
      return fetchWithToken<VirtualFolderResponse>(url, {
        method: HttpMethod.Post,
        headers,
      });
    },
  };
};

export default VirtualFoldersApi;
